///////////////////////////////////////////////////////////////
/* Component / ReactJS Library Imports */

import React, { Component } from 'react';
import Navigation from '../../components/Navigation';
import PagePhoto from '../../components/PagePhoto';
import coverPhoto from '../../Photos/Covers/About.jpg';
import Footer from '../../components/Footer';

import FlatList from 'flatlist-react';



///////////////////////////////////////////////////////////////
/* CSS Imports */

import './GeneralMeetings.css';



///////////////////////////////////////////////////////////////
/* Accent Photo Imports */

//import rightsun from '../../Photos/Icons/rightsun.png';
//import leftsun from '../../Photos/Icons/leftsun.png';
import sun from '../../Photos/Icons/sun.png';




class GeneralMeetings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            gmSignInLink: '',
            gmSlides: [],
        }
        
    }


    // Add constructor here when necessary
    
    componentDidMount() {
        window.scrollTo(0, 0)
    }

    renderGMSlides = (item, idx) => {
        return(
            <a href={item["link"]} target="_blank" rel="noopener noreferrer">
                <button className="gmSlideButton">
                    {item["name"]}
                </button>
            </a>
        )
    }

    /*this.setState({gmSlides: [] }) */

    render(){
        return (
            <div>
                <Navigation transparentNav={false} />
                <PagePhoto imageSource={coverPhoto} title={"General Meetings"}></PagePhoto>
                <br/>

           
                <div className = "titleFont1">
                    <div style = {{width: '80%', margin: 'auto', marginTop: '-50px'}}>                                
                        <img className = "gmSun" src= {sun} alt="Yellow Sun"></img>
                    </div>
                    <div className = "staffMembersBoard" style={{paddingBottom: '0vw'}}>
                        General Meetings
                    </div>
                    {/* <div style={{textAlign: "center"}} className="gmIntro">
                       Sign-in here once form is available :)  
                    </div> */}

                </div>
                
                
                <div className="signInForm">
                    {this.state.gmSignInLink && this.state.gmSignInLink.trim() !== "" ? (
                        <iframe
                            className="responsive-iframe"
                            title="Sign-in Form"
                            src={this.state.gmSignInLink}
                        >
                            Loading…
                        </iframe>
                    ) : (
                        <p style={{ textAlign: "center", fontStyle: "italic", marginTop: "20px" }}>
                            GM sign-in link is not available yet!
                        </p>
                    )}
                </div>
               
                {/* Will add toggle function to admin page
                <div className="gmIntro">
                    <p>See you next meeting!</p>
                </div>
                */}

                <div className = "titleFont1">
                    <div style = {{width: '80%', margin: 'auto'}}>                                
                        <img className = "gmSun" src= {sun} alt="Yellow Sun"></img>
                    </div>
                    <div className = "staffMembersBoard">
                        GM Slides
                    </div>
                </div>
                <div className="gmSlides">
                    {this.state.gmSlides.length === 0 ? (
                        <p style={{ textAlign: "center", fontStyle: "italic", marginTop: "20px" }}>
                            No slides uploaded yet!
                        </p>
                    ) : (
                        <FlatList
                            list={this.state.gmSlides}
                            renderItem={this.renderGMSlides}
                        />
                    )}
                    
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                </div>



                <Footer/>
            </div>
        )
    }
}

export default GeneralMeetings;